import { createContext, useContext } from 'react'

interface FieldContextValue {
  required: boolean
}

const FieldContext = createContext<FieldContextValue>({ required: false })

function useFieldContext() {
  return useContext(FieldContext)
}

/**
 * The control's `required`: its own prop, else the enclosing Field's. `Field required` prints the
 * asterisk, so every control that can sit in a Field reads this to carry the attribute behind it.
 */
function useFieldRequired(own: boolean | undefined) {
  const field = useFieldContext()
  return own ?? field.required
}

export { FieldContext, useFieldContext, useFieldRequired }
